import React from 'react'
import { COLORES } from '../../../../../config/colores'
import { Row, Col } from 'react-bootstrap'

function DatosHistoriaCpaPorCodigo (props) {
  const { cpaPorCodigo } = props

  const renderEstadoCpa = () => {
    const estadoCpa = cpaPorCodigo.map((cpa, i) => {
      const ultimoCpa = (i === 0)
      const fecha = new Date(cpa.fechaDeAlta * 1000)
      const cargaRechazada = (cpa.rechazoAdministrativoCalado || cpa.estadoCtg === 'R' || cpa.estadoCalificacion === 'R')

      return (
        <Row
          key={cpa.numero}
          style={{
            fontWeight: ultimoCpa ? 'bold' : 'inherit',
            border: ultimoCpa ? '2px solid' : 'none',
            backgroundColor: ultimoCpa ? COLORES.grey.light : 'inherit',
            borderRadius: '18px',
            margin: '8px auto',
            padding: '5px'
          }}
        >
          <Col md={3} style={{ textAlign: 'center' }} > Número: <b>{cpa.numero}</b> </Col>
          <Col md={3} style={{ textAlign: 'center' }} > Ingreso:
            <b> {fecha.toLocaleString([], { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' })} </b>
          </Col>
          {cpa.camion ? <Col md={3} style={{ textAlign: 'center' }} > Camión:  <b>{cpa.camion}</b> </Col> : <Col md={2} /> }
          {cpa.estadoCarga
            ? <Col md={3} style={{ textAlign: 'center' }} >
                                     Estado: {!cpa.turnoDeSalida
                ? <b> SIN TURNO SALIDA</b>
                : cargaRechazada ? <b>RECHAZADO</b>
                  : <b>{(cpa.estadoCarga).toUpperCase()}</b>
              }
            </Col>
            : <Col md={3} />
          }
        </Row>
      )
    })
    return estadoCpa
  }

  return (
    <div style={{ margin: '2% 0 0 0' }}>
      <h5 style={{ textAlign: 'center', margin: '3% 0 2% 0' }} >
                Carta de porte ingresada con el código de cupo
      </h5>
      { renderEstadoCpa() }
    </div>
  )
}

export default DatosHistoriaCpaPorCodigo
